<template>
  <div>
    <div class="mb-1">
      <code>{{ itemData.item.block_key }}</code>
    </div>
    <b-form-group
      v-for="field in fields"
      :key="field.key"
      :label="field.label"
      :label-for="field.key"
    >
      <b-form-textarea
        v-if="field.textarea"
        :id="field.key"
        v-model="itemData.translate[field.key]"
        rows="4"
        :placeholder="field.label"
      />
      <b-form-input
        v-else
        :id="field.key"
        v-model="itemData.translate[field.key]"
        :placeholder="field.label"
      />
      <b-alert
        v-if="itemData.item[field.key]"
        show
      >
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item[field.key] }}
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BAlert, BButton,
} from 'bootstrap-vue'

export default {
  name: 'SiteBlocks',
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAlert,
    BButton,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      fields: [
        { key: 'eyebrow', label: 'Üst Başlık' },
        { key: 'title', label: 'Başlık' },
        { key: 'subtitle', label: 'Alt Başlık' },
        { key: 'text', label: 'Metin', textarea: true },
        { key: 'button', label: 'Buton Metni' },
      ],
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
